import { BoxV2Icon } from '@jouzen/ecom-components/icons/BoxV2Icon';
import { RingOutlineIcon } from '@jouzen/ecom-components/icons/RingOutlineIcon';
import { ThumbsUpIcon } from '@jouzen/ecom-components/icons/ThumbsUpIcon';
import type { MessageKey } from 'types/LocaleMessageKey';

interface Step {
  answer: MessageKey;
  id: string;
  question: MessageKey;
  icon: React.ReactNode;
}

export const igShopSteps: Step[] = [
  {
    answer: 'meta_step_1_subcopy',
    id: 'meta_step_1',
    question: 'meta_step_1_copy',
    icon: <BoxV2Icon />,
  },
  {
    answer: 'meta_step_2_subcopy',
    id: 'meta_step_2',
    question: 'meta_step_2_copy',
    icon: <ThumbsUpIcon />,
  },
  {
    answer: 'meta_step_3_subcopy',
    id: 'meta_step_3',
    question: 'meta_step_3_copy',
    icon: <RingOutlineIcon />,
  },
];
